import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { remixerApi } from 'services/api/remixer';
import { actions } from 'services/store/remixer';
import useHistoryItem from './useHistoryItem';

type UseRemixActions = {
  deleteRemix: () => void;
  retryRemix: () => void;
};

const useRemixActions = (): UseRemixActions => {
  const dispatch = useDispatch();

  const { deleteSongRemix } = actions;

  const [remixSong] = remixerApi.useRemixSongMutation();

  const historyItem = useHistoryItem();

  const deleteRemix = useCallback(() => {
    dispatch(deleteSongRemix());
  }, [dispatch, deleteSongRemix]);

  const retryRemix = useCallback(() => {
    const formula = historyItem?.formula;

    if (!formula) {
      deleteRemix();
      return;
    }

    deleteRemix();
    remixSong(formula);
  }, [deleteRemix, remixSong, historyItem]);

  return { deleteRemix, retryRemix };
};

export default useRemixActions;
